import React from 'react';
import { motion } from 'framer-motion';

interface LandingButtonProps {
  onClick: () => void;
}

/**
 * Floating Landing Page Button Component
 * Allows users to return to the landing/home page from anywhere in the app
 */
export const LandingButton: React.FC<LandingButtonProps> = ({ onClick }) => {
  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.4, type: 'spring', stiffness: 300, damping: 25 }}
      className="fixed z-40 pointer-events-none"
      style={{
        bottom: 'calc(var(--bottom-nav-height) + max(env(safe-area-inset-bottom), 16px) + 88px)',
        right: '20px'
      }}
    >
      <motion.button
        onClick={onClick}
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.95 }}
        className="pointer-events-auto relative w-14 h-14 rounded-full shadow-xl hover:shadow-2xl
          transition-all duration-300 flex items-center justify-center
          backdrop-blur-xl border-2
          bg-gradient-to-br from-earth-500 to-earth-600 dark:from-earth-600 dark:to-earth-700
          border-earth-400/50 dark:border-earth-500/50 text-white
          hover:from-earth-600 hover:to-earth-700 dark:hover:from-earth-500 dark:hover:to-earth-600
        "
        aria-label="Go to landing page"
        title="View landing page"
      >
        {/* Animated Icon */}
        <motion.div
          whileHover={{ rotate: 5 }}
          className="flex items-center justify-center text-2xl"
        >
          ✈️
        </motion.div>

        {/* Glow Effect */}
        <motion.div
          className="absolute inset-0 rounded-full bg-earth-400/30"
          animate={{ 
            scale: [1, 1.3, 1],
            opacity: [0.4, 0, 0.4]
          }}
          transition={{ 
            repeat: Infinity, 
            duration: 3,
            ease: 'easeInOut'
          }}
        />
      </motion.button>
    </motion.div>
  );
};
